<div class="row g-0 about-us-card">
<!-- Close button -->
  <button 
    type="button" 
    class="btn-close position-absolute m-3" 
    aria-label="Close"
    (click)="closeCard()">
  </button>
 
  <div class="col-md-4 p-4 about-us-bg d-flex flex-column justify-content-start">
    <h2 class="text-orange fs-4 fw-bold mb-3">Where Ideation Meets Execution</h2>
    <p class="text-gray small mb-0">
      Kalpita, an outcome-focused company aimed at delivering unique, reliable, 
      and innovative software solutions using an agile approach to rapid software 
      delivery for small and large-scale businesses.
    </p>
  </div>
  
  <div class="col-md-8 p-4 bg-white">
    <h3>About Us</h3>
    <ul class="list-unstyled mb-0">
      <li><a routerLink="/aboutcompany/about-kalpita-technologies" class="dropdown-item" (click)="closeCard()">About Kalpita</a></li>
      <li><a routerLink="/aboutcompany/company-facts" class="dropdown-item" (click)="closeCard()">Company Facts</a></li>
      <li><a routerLink="/aboutcompany/kalpita-csr" class="dropdown-item"
       (click)="closeCard()" >Social Responsibility</a></li>
    <li>
        <a routerLink="/news-letters/newsletter" class="dropdown-item"
           (click)="closeCard()">News Letter</a>
    </li>
    <li>
        <a routerLink="/aboutcompany/kalpita-annual-reports" class="dropdown-item"
           (click)="closeCard()">Annual Report</a>
    </li>
       <li><a class="dropdown-item" href="../../../assets/brochure/Kalpita_Brochure.pdf" target="_blank" rel="noopener noreferrer">KT Brochure</a></li>
    </ul>
  </div>
</div>